import styled from 'styled-components';

export const Header = styled.div`
  width: 100%;
  text-transform: uppercase;
`;
